var app = angular.module('directives.smsConfirm', []);

require('./directives/smsConfirm.js');
require('./templates/smsConfirm.html');
require('./stylesheets/index.scss');

module.exports = app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/smsConfirm/index.js
 ** module id = 236
 ** module chunks = 1
 **/